export const malouChartColorGreen = '#9AEABA';
export const malouChartColorRed = '#FFBBC7';

export const malouChartColorText1 = '#0A2540';
export const malouChartColorText2 = '#4A5E73';

export const malouChartColorLighterBlue = '#F2F2FF';

export type ChartDataElement = number | null;
export type ChartDataArray = ChartDataElement[];
